module.exports = __webpack_public_path__ + "media/intro_web_mobile_video.8c684b4f.mp4";